import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';

export interface DialogUploadData {
  isImage: boolean;
  useFormName: string;
  attachmentName: string;
  attachmentType: string;
  attachmentCreatedDate: string;
  attachmentUploadDate: string;
  uploadFileName: string;
  uploadFile: Blob;
}

@Component({
  selector: 'ebb-portal-dialog-upload',
  templateUrl: './dialog-upload.component.html'
})
export class DialogUploadComponent implements OnInit {
  @Input('title') title = 'Upload file';
  public createdDate = new Date().toLocaleDateString();

  public displayFileName = 'No file selected.'
  public fileError = false;
  public fileSelected: any;
  public fileLocalUrl: any;
  public displayFileUrl: any = null;
  public disableFileSave = true;
  public showRotateImage = false;
  public imageOrientation = -1;
  public rotateDegree = 90;

  //public attachmentBase64 = 'data:image/png;base64,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';
  public attachmentBase64 = 'data:image/png;base64,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';
  public fileMaxSize = 15;
  readonly fileAcceptedTypes: string[] = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png'
  ];
  readonly imageAcceptedTypes: string[] = [
    'image/jpeg',
    'image/png'
  ];

  public formUpload: FormGroup;

  public showAttachmentCreatedDate = false;

  constructor(
    public dialogRef: MatDialogRef<DialogUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogUploadData,
    private fb: FormBuilder,
    private imageCompress: NgxImageCompressService
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.initializeNaming();
  }

  private initializeForm(): void {
    this.formUpload = this.fb.group({
      AttachmentName: ['', Validators.required],
      AttachmentCreatedDate: [Date, Validators.required],
      AttachmentUploadDate: [Date, Validators.required]
    });
  }

  private initializeNaming(): void {
    if (this.data.attachmentName.length) {
      this.formUpload.get('AttachmentName').setValue(this.data.attachmentName);
    }
  }

  public ebbFileInputChange(event: any) {
    this.disableFileSave = true;
    this.fileError = false;
    this.imageOrientation = -1;
    if (event.target.files.length > 0) {
      this.fileSelected = event.target.files[0];
      if ( !this.isValidFileType(this.fileSelected) )
      {
        this.fileError = true;
        if (this.data.isImage) {
          this.displayFileName = `Only the following types of files can be uploaded: JPG, PNG.`;
        } else {
          this.displayFileName = `Only the following types of files can be uploaded: PDF, DOCX, JPG, PNG.`;
        }
        return;
      }
      if ( !this.checkFileSize(this.fileSelected) )
      {
        this.fileError = true;
        this.displayFileName = `The file size must be less than ${this.fileMaxSize}MB`;
        return;
      }
      if ( this.fileSelected.type === 'application/pdf'
          || this.fileSelected.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        this.data.uploadFile = this.fileSelected;
        this.data.uploadFileName = this.fileSelected.name;
        this.displayFileName = `File: ${this.fileSelected.name}`;
        this.displayFileUrl = this.attachmentBase64;
        this.disableFileSave = false;
      } else {
        //if (this.fileSelected.size > 0)
        //{
          this.displayFileName = this.fileSelected.name;
          this.data.uploadFileName = this.fileSelected.name;
          const reader = new FileReader();
          reader.onload = (event: any) => {
            this.fileLocalUrl = event.target.result;
            this.imageCanvasResize(this.fileLocalUrl, 1000, 1000).then(compressed => {
              this.displayFileUrl = compressed;
              this.data.uploadFile = this.dataURItoBlob(this.displayFileUrl.split(',')[1]);;
              this.disableFileSave = false;
              this.showRotateImage = true;
            })
          }
          reader.readAsDataURL(event.target.files[0]);
        //}
        // else {
        //   const reader = new FileReader();
        //   reader.onload = (event: any) => {
        //     this.displayFileUrl = event.target.result;
        //   }
        //   reader.readAsDataURL(event.target.files[0]);
        //   this.data.uploadFile = this.fileSelected;
        //   this.data.uploadFileName = this.fileSelected.name;
        // }
        this.disableFileSave = false;
      }
      //in other projects have used form.reset() to re-enable file upload buttons
      const attachmentName = this.formUpload.get('AttachmentName').value;
      this.formUpload.reset();
      this.formUpload.get('AttachmentName').setValue(attachmentName);
    } else {
      this.displayFileUrl = null;
      console.log(`File not loaded.`);
    }
  }

  public imageCanvasResize(src, maxX, maxY) {
    return new Promise((res,rej) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
        const elem = document.createElement('canvas');
        const maxWidth = maxX;
        const maxHeight = maxY;
        let ratio = 1;
        if (img.width < maxWidth && img.height < maxHeight) {
          const ratio = 1;
        }
        else {
          const ratioX = maxWidth / img.width;
          const ratioY = maxHeight / img.height;
          ratio = ratioX < ratioY ? ratioX : ratioY;
          //console.log(`comression ratio: ${ratio}`);
        }
        const finalWidth = img.width * ratio;
        const finalHeight = img.height * ratio;
        // console.log(`finalWidth: ${finalWidth}`);
        // console.log(`finalHeight: ${finalHeight}`);
        elem.width = Math.round(finalWidth);
        elem.height = Math.round(finalHeight);
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, finalWidth, finalHeight);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => {
  const message = error instanceof Error ? error.message : ' failed to load';
  rej(new Error(` load error: ${message}`));
};
    })
  }

  public imageCompressFile(image, fileName) {
    const orientation = this.imageOrientation;
    this.imageCompress.compressFile(image, orientation, 50, 50).then(
      result => {
        this.displayFileUrl = result;
        this.data.uploadFile = this.dataURItoBlob(this.displayFileUrl.split(',')[1]);
        this.disableFileSave = false;
        this.showRotateImage = true;
      }
    );
  }

  public rotateImageOrientation(): void {
    switch(this.imageOrientation) {
      case -1:
        this.imageOrientation = 6;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
        break;
      case 6:
          this.imageOrientation = 3;
          this.rotateDegree = 180;
          this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
          break;
      case 3:
        this.imageOrientation = -1;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
        break
      default:
        this.imageOrientation = -1;
        this.rotateDegree = 90;
        this.imageCompressFile(this.fileLocalUrl, this.data.uploadFileName);
    }
  }

  public dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
}

  public isValidFileType(file: Blob): boolean {
    let validType: boolean;
    if (this.data.isImage) {
      validType = this.imageAcceptedTypes.indexOf(file.type) > -1;
    } else {
      validType = this.fileAcceptedTypes.indexOf(file.type) > -1;
    }
    return validType;
  }

  public checkFileSize(file: Blob): boolean {
    let validSize = false;

    const fileSize: number = parseFloat((file.size / (1024 * 1024)).toFixed(3));

    ( (Math.round(fileSize*1000)) > (this.fileMaxSize*1000) ) ?
      validSize = false : validSize = true;

    return validSize;
  }

  public onClickCancel(): void {
    this.dialogRef.close();
  }
}
